import Translations from "./app/api/localization-keys.json";

export type TranslationToken = keyof typeof Translations;

const translationObject = Translations as {
	[key in TranslationToken]: key;
};

export {translationObject as Translations};
